import { UseQueryOptions, useQuery } from '@tanstack/react-query'

import { getWorkspacesFromImportRequests } from 'services/import-requests'
import { ImportRequestQueryKeys } from 'services/import-requests/queryKeys'
import type { GetImportRequestFilterWorkspacesResponse } from 'services/import-requests/types'
import type { ApiErrorResponse } from 'services/types'

export const useGetWorkspacesFromImportRequests = (
  options?: Omit<UseQueryOptions<GetImportRequestFilterWorkspacesResponse, ApiErrorResponse>, 'queryKey'>
) =>
  useQuery<GetImportRequestFilterWorkspacesResponse, ApiErrorResponse>({
    queryKey: ImportRequestQueryKeys.FilterWorkspaces(),
    queryFn: ({ signal }) => getWorkspacesFromImportRequests({ signal }),
    ...options
  })
